import { FC } from "react";

import { FacetComponentProps } from "./@types/facet.types";
import { FacetType } from "./@types/facetType.types";
import { ColorswatchFacet } from "./components/ColorswatchFacet/colorswatchFacet.container";
import { DefaultFacet } from "./components/DefaultFacet/defaultFacet.container";
import { HierarchicalFacet } from "./components/HierarchicalFacet/hierarchicalFacet.container";
import { NumericFacet } from "./components/NumericFacet/numericFacet.container";
import { ShowProductsFacet } from "./components/ShowProductsFacet/showProductsFacet.container";
import { UnitRangeFacet } from "./components/UnitRangeFacet/unitRangeFacet.container";

const facetTypeToComponentMap = {
    [FacetType.DEFAULT]: DefaultFacet,
    [FacetType.NUMERIC]: NumericFacet,
    [FacetType.COLORSWATCH]: ColorswatchFacet,
    [FacetType.UNIT_RANGE]: UnitRangeFacet,
    [FacetType.HIERARCHICAL]: HierarchicalFacet,
    [FacetType.SHOW_PRODUCTS]: ShowProductsFacet
} as const;

const getComponentForFacetType = <TFacetType extends FacetType>(
    facetType: TFacetType
) => facetTypeToComponentMap[facetType] as FC<FacetComponentProps<TFacetType>>;

export { getComponentForFacetType };
